module.exports = __webpack_public_path__ + "img/orai.59015094.svg";